var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"Copyright"},[_vm._v("Copyright ©\n\t\t\t\n\t\t\t2019\n\t\t\t中泽医药 Inc. 保留所有权利。")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4c76d2a7","hasScoped":false,"buble":{"transforms":{}}}!./~/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 236
// module chunks = 1